import { render } from "./IconProfile.vue?vue&type=template&id=7b8f6f00&scoped=true&ts=true"
import script from "./IconProfile.vue?vue&type=script&lang=ts"
export * from "./IconProfile.vue?vue&type=script&lang=ts"

import "./IconProfile.vue?vue&type=style&index=0&id=7b8f6f00&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b8f6f00"]])

export default __exports__